import {
    REQUEST_GOALS,
    RECEIVE_GOALS,
    RECEIVE_ALL_GOALS,
    DELETE_GOAL,
    UPDATING_GOAL,
    UPDATE_GOAL_SUCCESS,
    UPDATE_GOAL_FAIL,
    CREATING_GOAL,
    CREATE_GOAL_SUCCESS,
    CREATE_GOAL_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    lastDeletedGoal: null,
    updatingGoal: false,
    updateGoalSuccess: false,
    updateGoalFail: false,
    creatingGoal: false,
    createGoalSuccess: false,
    createGoalFail: false,
    entity: [],
    allGoals: {},
    hasMorePastGoals: false
};

const requestGoals = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const combineGoals = (state, receivedGoals = [], goalStatus) => {
    let existingGoals = state.allGoals?.[goalStatus] || [];
    let combinedGoals = [];

    existingGoals.forEach((oldGoal) => {
        if (!receivedGoals.find((newGoal) => newGoal.id === oldGoal.id)) {
            combinedGoals.push(oldGoal);
        }
    });

    combinedGoals = [...combinedGoals, ...receivedGoals];

    return combinedGoals;
};

const receiveGoals = (state, action) => {
    return {
        ...state,
        entity: action.goals,
        allGoals: {
            [action.status]: action.replace ? action.goals : combineGoals(state, action.goals, action.status)
        },
        hasMorePastGoals: action.goals.length === action.limit,
        isFetching: false,
        lastUpdated: action.receivedAt
    };
};

const receiveAllGoals = (state, action) => {
    return {
        ...state,
        allGoals: action.goals,
        hasMorePastGoals: action.goals.past.length === action.limit,
        isFetching: false,
        lastUpdated: action.receivedAt
    };
};

const deleteGoal = (state, action) => {
    return {
        ...state,
        lastDeletedGoal: action.goalId
    };
};

const updatingGoal = (state) => {
    return {
        ...state,
        updatingGoal: true,
        updateGoalSuccess: false,
        updateGoalFail: false
    };
};

const updateGoalSuccess = (state) => {
    return {
        ...state,
        updatingGoal: false,
        updateGoalSuccess: true,
        updateGoalFail: false
    };
};

const updateGoalFail = (state) => {
    return {
        ...state,
        updatingGoal: false,
        updateGoalSuccess: false,
        updateGoalFail: true
    };
};

const creatingGoal = (state) => {
    return {
        ...state,
        creatingGoal: true,
        createGoalSuccess: false,
        createGoalFail: false
    };
};

const createGoalSuccess = (state) => {
    return {
        ...state,
        creatingGoal: false,
        createGoalSuccess: true,
        createGoalFail: false
    };
};

const createGoalFail = (state) => {
    return {
        ...state,
        creatingGoal: false,
        createGoalSuccess: false,
        createGoalFail: true
    };
};

const handlers = {
    [REQUEST_GOALS]: requestGoals,
    [RECEIVE_GOALS]: receiveGoals,
    [RECEIVE_ALL_GOALS]: receiveAllGoals,
    [DELETE_GOAL]: deleteGoal,
    [CREATING_GOAL]: creatingGoal,
    [CREATE_GOAL_SUCCESS]: createGoalSuccess,
    [CREATE_GOAL_FAIL]: createGoalFail,
    [UPDATING_GOAL]: updatingGoal,
    [UPDATE_GOAL_SUCCESS]: updateGoalSuccess,
    [UPDATE_GOAL_FAIL]: updateGoalFail
};

export const getGoals = (state, status) => {
    if (status) {
        return state.allGoals[status];
    }
    return state.goals.entity;
};

export const getAllGoals = (state) => {
    return state.goals.allGoals;
};

export const isUpdatingGoal = (state) => {
    return state.goals.updatingGoal;
};

export const isCreatingGoal = (state) => {
    return state.goals.creatingGoal;
};

export const hasMorePastGoals = (state) => {
    return state.goals.hasMorePastGoals;
};

export default function goals(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
